import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    TgGridModule,
    TgSvgModule,
    TgModalModule,
    TgToggleModule,
    TgCardModule,
    TgRadioModule,
    TgCurrencyFormatterModule,
    TgLists2Module,
    TgIconBasicTickModule,
    TgIconBasicCrossModule,
    TgIconEyeModule
} from '@trademe/tangram';
import { MotorsIllustrationBoatModule } from '../../components/motors-illustration-boat/motors-illustration-boat.module';
import { MotorsListingDetailsPackageSectionComponent } from './motors-listing-details-package-section.component';
import { DraftValidationModule, TrademeCoreUiPipeModule } from '@classifieds-sell/shared';
import { CardSelectionDirective } from './card-selection.directive';
import { ZeroChangeFontSizePipe } from './zero-change-font-size.pipe';

@NgModule({
    imports: [
        CommonModule,
        TgGridModule,
        TgSvgModule,
        TgModalModule,
        TgToggleModule,
        TgCardModule,
        TgRadioModule,
        TgCurrencyFormatterModule,
        TgLists2Module,
        TgIconBasicTickModule,
        TgIconBasicCrossModule,
        TgIconEyeModule,
        DraftValidationModule,
        TrademeCoreUiPipeModule,
        MotorsIllustrationBoatModule
    ],
    declarations: [MotorsListingDetailsPackageSectionComponent, CardSelectionDirective, ZeroChangeFontSizePipe],
    exports: [MotorsListingDetailsPackageSectionComponent]
})
export class MotorsListingDetailsPackageSectionModule { }
